import useColDeleteSchema from './columns/useColDeleteSchema';
import useColLinkSchema from './columns/useColLinkSchema';
import { PROJECT_PREFIX } from '../../../const';

export default function useVideoSchema({ onDelete }) {
    const colDeleteSchema = useColDeleteSchema({ onDelete });
    const colTitleSchema = useColLinkSchema({
        type: 'title',
        accessor: 'title',
        title: 'Заголовок',
        defaultData: 'Без названия',
        getUrl: (row) => `${PROJECT_PREFIX}/video/${row.id}/`,
        target: '_self',
    });

    return [
        colTitleSchema,
        { accessor: 'description', title: 'Описание' },
        {
            accessor: 'games',
            title: 'Игры',
            render: ({ currentData }) => currentData.map(({ name }) => name).join(', '),
        },
        colDeleteSchema,
    ];
}
